"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var history_1 = require("@pbl/pbl-react-core/lib/models/history");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
var moment_1 = __importDefault(require("moment"));
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../config/constants"));
var actions_1 = require("../../../redux/reducers/app/actions");
var filters_1 = require("../../../utils/filters");
var useTicketEntriesHistory = function (isLoggedIn) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = React.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = React.useState(filters_1.dateFilter), filter = _b[0], setFilter = _b[1];
    var _c = React.useState(new history_1.TicketEntryHistoryList()), data = _c[0], setData = _c[1];
    var _d = React.useState({}), page = _d[0], setPage = _d[1];
    React.useEffect(function () {
        if (isLoggedIn) {
            getTicketsData(0);
        }
    }, [filter]);
    var fetchData = function (_a) {
        var pageNumber = _a.pageNumber, sort = _a.sort, dateStart = _a.dateStart, dateEnd = _a.dateEnd;
        return __awaiter(void 0, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, services_1.HistoryService.getUserTicketEntriesHistory(constants_1.default.HISTORY_ITEMS_PER_PAGE, pageNumber, sort, dateStart, dateEnd, constants_1.default.SHOW_TICKET_ENTRY_HISTORY_WITHOUT_MASK)];
                    case 2:
                        response = _b.sent();
                        setData(response.data);
                        setPage(response.page);
                        setLoading(false);
                        return [3, 4];
                    case 3:
                        e_1 = _b.sent();
                        dispatch((0, actions_1.showMessageBar)({ message: e_1.message, type: 'error' }));
                        setLoading(false);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    var resetData = function () {
        setData(new history_1.TicketEntryHistoryList());
        setPage({});
    };
    var getTicketsData = function (pageNumber, reset) {
        var _a, _b, _c, _d, _e;
        if (reset === void 0) { reset = false; }
        var selectedFilter = (_a = filter === null || filter === void 0 ? void 0 : filter.filters) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.isSelected; });
        if ((selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.customDateRangeStart) && (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.customDateRangeEnd)) {
            var startDate = new Date((0, TimeUtil_1.formatDateDayMonthYear)((_c = (_b = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.customDateRangeStart) === null || _b === void 0 ? void 0 : _b.clone()) === null || _c === void 0 ? void 0 : _c.toDate())).toISOString();
            var formattedDate = (0, moment_1.default)((0, TimeUtil_1.formatDateDayMonthYear)((_e = (_d = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.customDateRangeEnd) === null || _d === void 0 ? void 0 : _d.clone()) === null || _e === void 0 ? void 0 : _e.toDate())).format('YYYY-MM-DD');
            var endDate = new Date("".concat(formattedDate, "T23:59:59.999Z")).toISOString();
            if (reset) {
                resetData();
                return;
            }
            fetchData({
                pageNumber: pageNumber,
                dateStart: startDate ? startDate : undefined,
                dateEnd: endDate ? endDate : undefined
            });
        }
    };
    var toggleFilter = function (filters, resetCustomDateFilter) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var filterKey = (_d = (_c = (_b = (_a = filters[filters_1.filterSections.DateFilterIndex]) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.find(function (f) { return f.isSelected; })) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : undefined;
        var customDateFilterTypeData = (_g = (_f = (_e = filters[filters_1.filterSections.DateFilterIndex]) === null || _e === void 0 ? void 0 : _e.filters) === null || _f === void 0 ? void 0 : _f.find(function (f) { return f.customDateFilterType === 'custom'; })) !== null && _g !== void 0 ? _g : undefined;
        setFilter(__assign(__assign({}, filter), { filters: (_h = filter === null || filter === void 0 ? void 0 : filter.filters) === null || _h === void 0 ? void 0 : _h.map(function (f) { return (__assign(__assign(__assign({}, f), { isSelected: f.name === filterKey ? !f.isSelected : false }), ((f.name === filterKey || resetCustomDateFilter) && f.customDateFilterType === 'custom'
                ? {
                    customDateRangeStart: resetCustomDateFilter ? null : (customDateFilterTypeData === null || customDateFilterTypeData === void 0 ? void 0 : customDateFilterTypeData.customDateRangeStart) || null,
                    customDateRangeEnd: resetCustomDateFilter ? null : (customDateFilterTypeData === null || customDateFilterTypeData === void 0 ? void 0 : customDateFilterTypeData.customDateRangeEnd) || null
                }
                : {}))); }) }));
    };
    return { data: data, page: page, loading: loading, fetchData: fetchData, filter: filter, toggleFilter: toggleFilter, setFilter: setFilter, getTicketsData: getTicketsData };
};
exports.default = useTicketEntriesHistory;
//# sourceMappingURL=useTicketEntriesHistory.js.map